import React from "react";
import { ThumbsDownIcon, ThumbsUpIcon } from "hugeicons-react";
import { HoverToolTip } from "../Layout/Items/HoverToolTip";
import { useChatContext } from "../../contexts/AppDataContext";
import { useAuth } from "../../contexts/AuthContext";
import { ConvexMessage } from "../../types/message";
import { Mode } from "../../types/mode";
import { DropdownMenuRow } from "../ui/dropdown-menu";

interface MessageRatingButtonsProps {
  message: ConvexMessage;
  currentMode: Mode;
  onRegenerate: (messageId: string, mode: Mode) => Promise<void>;
  /** Toolbar buttons (default) or menu rows for use inside DropdownMenuContent */
  layout?: "toolbar" | "menu";
}

export const MessageRatingButtons: React.FC<MessageRatingButtonsProps> = ({
  message,
  currentMode,
  onRegenerate,
  layout = "toolbar",
}) => {
  const { rateMessage } = useChatContext();
  const auth = useAuth();

  const isLiked = message.isLiked || false;
  const isDisliked = message.isDisliked || false;

  const handleDisLikeMessage = async () => {
    try {
      await rateMessage(message._id, 'dislike');
      if (
        auth.user &&
        auth.chatUsageData &&
        (auth.chatUsageData.remaining === null || auth.chatUsageData.remaining > 0)
      ) {
        onRegenerate(message._id, (message.mode as unknown as Mode || currentMode));
      }
    } catch (error) {
      console.error('Error disliking message', error);
    }
  };

  const handleLikeMessage = async () => {
    try {
      await rateMessage(message._id, 'like');
    } catch (error) {
      console.error('Error liking message', error);
    }
  };

  if (layout === "menu") {
    return (
      <>
        {!isDisliked && (
          <DropdownMenuRow
            className={isLiked ? "opacity-90" : undefined}
            icon={(
              <ThumbsUpIcon
                fill={isLiked ? "var(--text-muted)" : "var(--background-main)"}
              />
            )}
            text="Like Message"
            action={() => {
              void handleLikeMessage();
            }}
          />
        )}
        {!isLiked && (
          <DropdownMenuRow
            className={isDisliked ? "opacity-90" : undefined}
            icon={(
              <ThumbsDownIcon
                fill={isDisliked ? "var(--text-muted)" : "var(--background-main)"}
              />
            )}
            text="Report Message"
            action={() => {
              void handleDisLikeMessage();
            }}
          />
        )}
      </>
    );
  }

  return (
    <>
      {!isDisliked && (
        <button
          className={`action-button rate-button ${isLiked ? "active" : ""}`}
          onClick={handleLikeMessage}
        >
          <ThumbsUpIcon fill={isLiked ? "var(--text-muted)" : "var(--background-main)"} size={17} />
          <HoverToolTip text="I like this" position="bottom" />
        </button>
      )}
      {!isLiked && (
        <button
          className={`action-button rate-button ${isDisliked ? "active" : ""}`}
          onClick={handleDisLikeMessage}
        >
          <ThumbsDownIcon fill={isDisliked ? "var(--text-muted)" : "var(--background-main)"} size={17} />
          <HoverToolTip text="I don't like this" position="bottom" />
        </button>
      )}
    </>
  );
};
